import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ShowComponent } from 'src/app/common/component/show.component';

export interface ProductKind {
	find(arg0: (item: any) => boolean);
	id: number;
	name: string;
	code: string;
}

export interface Multimedia {
	id: string;
	name: string;
	url: string;
}

export interface DescriptionHeaders {
	[x: string]: any;
	id: number;
	name: string;
	header: string;
	multimedia: Multimedia;
	comment: string;
}

export interface DescriptionTemplateHeader {
	id: number;
	order: number;
	source: string;
	commonDescriptionHeaders: DescriptionHeaders;
}

export interface DescriptionTemplate {
	id: number;
	productKind: number;
	kind: string;
	descriptionTemplateHeaders: DescriptionTemplateHeader[];
}

@Component({
	selector: 'app-www-description-template',
	templateUrl: './www-description-template.component.html',
	styleUrls: ['./www-description-template.component.scss'],
})
export class WwwDescriptionTemplateComponent extends ShowComponent {
	protected apiType = 'bag';
	protected parentComponent = 'www/descriptionTemplate';
	protected apiUrl = '/www/description_template/';
	protected apiUrlAdd = '/www/description_template/';
	protected title = `Szablon WWW`;

	protected productKind: ProductKind;
	protected descriptionHeaders: DescriptionHeaders;
	protected selectedHeader: DescriptionHeaders;

	protected tabKind: Array<any> = [
		{ id: 1, name: 'Opis', kind: 'D' },
		{ id: 2, name: 'Świadczenia', kind: 'B' },
		{ id: 3, name: 'Lokalizacja', kind: 'L' },
	];

	protected source: Array<any> = [
		{ id: 1, name: 'Produkt', code: 'P' },
		{ id: 2, name: 'Oferta', code: 'O' },
		{ id: 3, name: 'Lokalizacja', code: 'L' },
	];

	selectedSource = 'P';

	@ViewChild('dataTable') table: MatTable<any>;

	data: DescriptionTemplate = {
		descriptionTemplateHeaders: [],
		id: null,
		kind: null,
		productKind: null,
	};

	formGroup: FormGroup;

	tableData: any;
	headers: DescriptionTemplateHeader[];
	holdDescriptionTemplateHeader: DescriptionTemplateHeader[];
	headersToDel: Array<any> = [];
	offerDescription;
	private offerDescriptionAll;

	checkError = (controlName: string, errorName: string) => {
		return this.formGroup.controls[controlName].hasError(errorName);
	};

	displayedColumns: string[] = ['name', 'header', 'multimedia', `source`, 'delete'];

	protected loadBefore(): void {
		this.formGroup = new FormGroup({
			productKind: new FormControl({ disabled: !this.editable, value: '' }, [Validators.required]),
			kind: new FormControl({ disabled: !this.editable, value: '' }, [Validators.required]),
			source: new FormControl({ disabled: !this.editable, value: '' }, [Validators.required]),
			header: new FormControl({ disabled: !this.editable, value: '' }, [Validators.required]),
		});
		this.bag.get('/product/kind/', (result, error) => {
			this.productKind = result.results;
			this.loadData();
		});
		this.bag.get('/description_header/?limit=100', (result, error) => {
			this.descriptionHeaders = result.results;
			this.loadData();
		});
		this.bag.get('/offer/description/', (result, error) => {
			this.offerDescriptionAll = result.results;
			this.offerDescription = result.results;
			this.loadData();
		});
	}

	protected editEnable() {
		this.formGroup.get('productKind').enable();
		this.formGroup.get('kind').enable();
		this.formGroup.get('source').enable();
		this.formGroup.get('header').enable();

		this.editable = true;
	}

	protected getApiUrl(): string {
		return '/www/description_template/' + this.data.id + '/';
	}

	protected afterLoadData(): void {
		this.headers = this.data.descriptionTemplateHeaders;
		this.tableData = new MatTableDataSource<any>(this.data.descriptionTemplateHeaders);
		this.filterDescriptionHeader();
	}

	protected pageTitleGenerate(): string {
		const productKind = this.productKind.find((item) => item.id === this.data.productKind);
		const kind = this.tabKind.find((item) => item.kind === this.data.kind);

		return `Szablon WWW - ${productKind?.name} | ${kind?.name}`;
	}

	dropTable(event: CdkDragDrop<any[]>): void {
		moveItemInArray(this.data.descriptionTemplateHeaders, event.previousIndex, event.currentIndex);
		this.setOrder();
		this.table.renderRows();
	}

	private filterDescriptionHeader() {
		if (this.headers.length === 0 || this.descriptionHeaders === undefined) {
			return;
		}
		const convertedHeaders = [];
		const convertedOfferHeaders = [];
		this.headers.forEach((item) => {
			if (item.source === 'O') {
				convertedOfferHeaders.push(item.commonDescriptionHeaders);
				return;
			}
			convertedHeaders.push(item.commonDescriptionHeaders);
		});

		this.offerDescription = this.offerDescription.filter(
			({ descriptionHeader: descriptionHeader }) =>
				!convertedOfferHeaders.some(({ id: id }) => id === descriptionHeader.id),
		);

		this.descriptionHeaders = this.descriptionHeaders.filter(
			({ id: id1 }) => !convertedHeaders.some(({ id: id2 }) => id2 === id1),
		);
	}

	protected convertData(data: any) {
		data.descriptionTemplateHeaders.forEach((item) => {
			if (item.commonDescriptionHeaders.multimedia === null) {
				item.commonDescriptionHeaders.multimedia = {
					name: 'Brak zdjęcia',
					isNull: true,
				};
				return;
			}
			item.commonDescriptionHeaders.multimedia['isNull'] = false;
		});
		data.descriptionTemplateHeaders.sort((a, b) => a.order - b.order);
		this.title = this.pageTitleGenerate();
		return data;
	}

	private setOrder() {
		this.data.descriptionTemplateHeaders.forEach((item, index) => {
			item.order = index + 1;
		});
	}

	selectHeader(header) {
		if (header.multimedia === null) {
			header.multimedia = {
				name: 'Brak zdjęcia',
				isNull: true,
			};
		} else header.multimedia['isNull'] = false;
		this.selectedHeader = header;
	}

	addHeader() {
		if (this.selectedHeader === undefined) {
			return;
		}
		const headerToAdd = {
			id: null,
			order: 1,
			source: this.selectedSource,
			commonDescriptionHeaders: this.selectedHeader,
		};
		if (this.headers.length !== 0) {
			headerToAdd.order = this.headers[this.headers.length - 1].order + 1;
		}

		this.headers.push(headerToAdd);

		this.filterDescriptionHeader();

		this.selectedHeader = null;
		this.table.renderRows();
	}

	deleteHeader(i) {
		if (this.data.descriptionTemplateHeaders[i].id != null) {
			this.headersToDel.push(this.data.descriptionTemplateHeaders[i].id);
		}
		if (this.data.descriptionTemplateHeaders[i].source === 'O') {
			const deletedHeader = this.offerDescriptionAll.find(
				(item) =>
					item.descriptionHeader.id === this.data.descriptionTemplateHeaders[i].commonDescriptionHeaders.id,
			);
			this.offerDescription.push(deletedHeader);
		} else {
			this.descriptionHeaders.push(this.data.descriptionTemplateHeaders[i].commonDescriptionHeaders);
		}

		this.data.descriptionTemplateHeaders.splice(i, 1);
		this.setOrder();
		this.table.renderRows();
	}

	convertSource(source) {
		switch (source) {
			case 'P':
				source = 'Produkt';
				break;
			case 'O':
				source = 'Oferta';
				break;
			case 'L':
				source = 'Lokalizacja';
				break;

			default:
				break;
		}
		return source;
	}

	private descriptionTemplateHeadersSend(result, templateHeaderIds) {
		result.descriptionTemplateHeaders = this.headers;
		result.descriptionTemplateHeaders.map((item) => {
			const headerToSend = {
				id: item.id,
				order: item.order,
				commonDescriptionHeaders: item.commonDescriptionHeaders.id,
				descriptionTemplate: result.id,
				source: item.source,
			};
			if (item.id === null) {
				return this.bag.post('/www/description_header/', headerToSend, (result, error) => {
					this.loader.hide();
					if (error) {
						this.loader.hide();
						return;
					}
					templateHeaderIds.push(result.id);
				});
			}
			this.bag.put('/www/description_header/' + item.id + '/', headerToSend, (result, error) => {
				this.loader.hide();
				if (error) {
					this.loader.hide();
					return;
				}
				templateHeaderIds.push(result.id);
			});
		});
	}

	private checkForm(name, error) {
		if (this.formGroup.controls[name].hasError(error)) {
			this.formGroup.controls[name].markAsTouched();
			this.infobox.error('Uzupełnij poprawnie wszystkie pola!');
			return false;
		}
		return true;
	}

	protected checkFormBeforeSubmit() {
		if (!this.checkForm('productKind', 'required')) {
			return;
		}
		if (!this.checkForm('kind', 'required')) {
			return;
		}
		this.bag.get('/www/description_template/', (result, error) => {
			const checkTemplates = result.results.find(
				(template) => template.productKind === this.data.productKind && template.kind === this.data.kind,
			);

			if (checkTemplates != undefined && checkTemplates.id != this.data.id) {
				this.infobox.error('Szablon z wybranym typem produktu i typem już istnieje!');
				return;
			}
			this.submit();
		});
	}

	protected submitBefore(): void {
		this.headersToDel.forEach((item) => {
			this.bag.del('/www/description_header/' + item + '/', (result, error) => {
				if (error) {
					return;
				}
			});
		});
	}

	protected submitConvert(data: any) {
		const templateHeaderIds = [];
		if (this.pageFunction === 'edit') {
			this.descriptionTemplateHeadersSend(data, templateHeaderIds);
		}

		this.holdDescriptionTemplateHeader = data.descriptionTemplateHeaders;
		data.descriptionTemplateHeaders = templateHeaderIds;
		return data;
	}

	protected afterSend(result: any, error: any): void {
		const templateHeaderIds = [];
		if (this.pageFunction === 'add') {
			this.descriptionTemplateHeadersSend(result, templateHeaderIds);
		}

		this.loader.hide();
		if (error) {
			return;
		}
		this.router.navigate([this.parentComponent, this.data.id]);
		this.pageFunction = 'edit';
		this.editable = false;
		this.title = this.pageTitleGenerate();
		this.apiUrl = this.getApiUrl();
		this.infobox.success('Zapisano');
		this.submitAfter();
	}

	protected submitAfter(): void {
		this.formGroup.get('productKind').disable();
		this.formGroup.get('kind').disable();
		this.formGroup.get('source').disable();
		this.formGroup.get('header').disable();
		this.data.descriptionTemplateHeaders = this.holdDescriptionTemplateHeader;
	}
}
